import { render } from "./Testimonialsection.vue?vue&type=template&id=a25c3e4e&scoped=true"
const script = {}

import "./Testimonialsection.vue?vue&type=style&index=0&id=a25c3e4e&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a25c3e4e"]])

export default __exports__